module.exports = __webpack_public_path__ + "img/sud-ouest.b3eb3c50.png";